import React from 'react';
import './SkeletonLoader.css';

export const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-header">
      <div className="skeleton-line skeleton-title"></div>
      <div className="skeleton-line skeleton-badge"></div>
    </div>
    <div className="skeleton-body">
      <div className="skeleton-line"></div>
      <div className="skeleton-line skeleton-short"></div>
    </div>
  </div>
);

export const SkeletonTable = ({ rows = 5, columns = 4 }) => (
  <div className="skeleton-table">
    <div className="skeleton-table-header">
      {Array.from({ length: columns }).map((_, i) => (
        <div key={i} className="skeleton-line skeleton-header-cell"></div>
      ))}
    </div>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex} className="skeleton-table-row">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div key={colIndex} className="skeleton-line skeleton-cell"></div>
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonText = ({ lines = 3, width = '100%' }) => (
  <div className="skeleton-text" style={{ width }}>
    {Array.from({ length: lines }).map((_, i) => (
      <div
        key={i}
        className="skeleton-line"
        style={{ width: i === lines - 1 ? '60%' : '100%' }}
      ></div>
    ))}
  </div>
);

export const SkeletonButton = () => (
  <div className="skeleton-button skeleton-line"></div>
);

export default SkeletonCard;











